<template>
  <div class="login-box">
      <div class="login-container">
        <div class="login-logo-box">
            <img src="../assets/images/logo-jys.png" class="login-logo" alt="" v-if="type === 'jys'">
            <img src="../assets/images/logo.png" class="login-logo" alt="" v-else>
        </div>
        <Form v-if="isLogin" :model="formInLine" class="login-details">
            <div class="login-title"><span class="title-label">{{titlePrefix}}<span>{{titleSuffix}}{{Version}}</span></span></div>
            <FormItem>
                <div class="login-input"><Input type="text" v-model="formInLine.user" prefix="ios-person-outline" size="large" placeholder="用户名"></Input></div>
            </FormItem>
            <FormItem>
                <div class="login-input"><Input type="password" v-model="formInLine.password" prefix="ios-lock-outline" size="large" placeholder="密码"></Input></div>
            </FormItem>
            <Row class="mb-10">
                <Col span="24" class="checabox">
                    <CheckboxGroup v-model="formInLine.checkbox">
                        <Checkbox label="记住我"></Checkbox>
                    </CheckboxGroup>
                </Col>
            </Row>
            <div>
                <Button type="primary" @click="handleSubmit('formInLine')" :loading="loading" long>
                    <span v-if="!loading">立即登录</span>
                    <span v-else>登录中...</span>
                </Button>
                <!-- <div class="register-box">
                    <label class="register-btn" @click="isLogin = false">注册账号</label>
                </div> -->
            </div>
        </Form>
        <!-- 登录表单 -->
        <Form v-if="!isLogin" key="2"
            ref="registerInLine"
            :model="registerInline"
            :rules="ruleInRLine"
            class="login-details">
            <div class="login-title"><span class="title-label">{{titlePrefix}}<span>{{titleSuffix}}{{Version}}</span></span></div>
            <FormItem prop="user">
                <div class="login-input"><Input type="text" v-model="registerInline.user" prefix="ios-person-outline" size="large" placeholder="用户名"></Input></div>
            </FormItem>
            <FormItem prop="password">
                <div class="login-input"><Input type="password" v-model="registerInline.password" prefix="ios-lock-outline" size="large" placeholder="密码"></Input></div>
            </FormItem>
            <FormItem prop="passwordTwo">
                <div class="login-input"><Input type="password" v-model="registerInline.passwordTwo" prefix="ios-lock-outline" size="large" placeholder="再次输入密码"></Input></div>
            </FormItem>
            <div>
                <Button type="primary" @click="handleSubmit('registerInLine')" long>注册</Button>
                <div class="register-box">
                    <label class="register-btn" @click="isLogin = true">返回登录</label>
                </div>
            </div>
        </Form>
    </div>
  </div>
</template>
<script>
import api from '@/api/index';
import JSEncrypt from 'jsencrypt';
import { titlePrefix, titleSuffix, type } from '@/config';
export default {
    data() {
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.registerInline.password) {
                callback(new Error('两次密码不一致'));
            } else {
                callback();
            }
        };
        return {
            formInLine: {
                user: localStorage.getItem('CMSSavePas') === 'true' ? localStorage.getItem('CMSUserName') : '',
                password: localStorage.getItem(localStorage.getItem('CMSUserName')),
                checkbox: localStorage.getItem('CMSSavePas') === 'true' ? ['记住我'] : []
            },
            registerInline: {
                user: '',
                password: '',
                passwordTwo: ''
            },
            ruleInRLine: {
                user: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                passwordTwo: [{ validator: validatePassCheck, trigger: 'blur' }]
            },
            isLogin: true,
            loading: false,
            Version: '',
            RSAPublicKey: '',
            titlePrefix: titlePrefix,
            titleSuffix: titleSuffix,
            type: type
        };
    },
    created() {
        this.getVersion();
    },
    methods: {
        // 获取RSA公钥
        async getRSAPublicKey() {
            const res = await api.common.getRSAPublicKey();
            if (res.code !== 200) {
                this.$Message.error(res.msg);
                return;
            }
            this.RSAPublicKey = res.data;
            this.login();
        },
        // 加密密码
        RSAPassword() {
            let encryptStr = new JSEncrypt();
            encryptStr.setPublicKey(this.RSAPublicKey); // 设置 加密公钥
            let data = encryptStr.encrypt(this.formInLine.password); // 进行加密
            return data;
        },
        // submit验证
        handleSubmit(name) {
            if (name === 'formInLine' && this.formInLine.user !== '' && this.formInLine.password !== '') {
                this.getRSAPublicKey();
                return;
            }
            this.$refs[name].validate((valid) => {
                if (!valid) {
                    return;
                }
                if (name === 'registerInLine') {
                    this.register();
                }
            });
        },
        // 登录
        async login() {
            this.loading = true;
            const res = await api.common.loginByRSA(this.formInLine.user, this.RSAPassword());
            this.loading = false;
            if (res.code !== 200) {
                this.$Message.error(res.msg);
                return;
            }
            this.$Message.success(res.msg);
            localStorage.setItem('CMSUserName', this.formInLine.user);
            if (this.formInLine.checkbox.length !== 0) {
                localStorage.setItem('CMSSavePas', true);
                localStorage.setItem(this.formInLine.user, this.formInLine.password);
            } else {
                localStorage.removeItem('CMSSavePas');
                localStorage.removeItem(this.formInLine.user);
            }
            localStorage.setItem('loginToken', Date.parse(new Date()));
            this.$store.commit('changeUser', res.data.user);
            this.$store.commit('changeDeptId', res.data.user.businessDept.deptID);
            localStorage.removeItem('VUEMenuRouter');
            this.$router.push({ path: '/industryNews/newestDynamics' });
        },
        // 注册
        async register() {
            const res = await api.common.regist(this.registerInline.user, this.registerInline.password);
            if (res.code !== 200) {
                this.$Message.error(res.msg);
                return;
            }
            this.$Message.success('注册成功！请登录');
            this.formInLine.user = '';
            this.formInLine.password = '';
            this.isLogin = true;
        },
        // 获取当前版本
        async getVersion() {
            const res = await api.common.getVersion();
            if (res.code !== 200) {
                return;
            }
            const showVersion = res.data.substr(0, res.data.lastIndexOf('.'));
            this.Version = showVersion !== '' ? ' - V' + showVersion : '';
        }
    }
};
</script>

<style lang="scss" scoped>
.login-box {
    width: 100%;
    height: 100%;
    background-image: url('../assets/images/background.jpg');
    background-position: top left;
    background-size: cover;
}
.login-container {
    position: absolute;
    top: 50%;
    height: 540px;
    margin-top: -330px;
    width: 100%;
    text-align: center;
}
.login-title {
    height: 50px;
    line-height: 50px;
    color: #3491ff;
    .title-label {
        font-size: 20px;
        font-weight: 600;
        border-bottom: 1px solid #3491ff;
        span {
            color: rgba(0,0,0,.85);
        }
    }
}
.login-logo-box {
    height: 230px;
    line-height: 120px;
    padding-bottom: 30px;
}
.login-logo {
    height: 100%;
}
.login-details {
    border-radius: 5px;
    background-clip: padding-box;
    display: inline-block;
    width: 400px;
    padding: 5px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 2px 2px 5px #cac6c6;
    .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
    }
    .remember {
        margin: 0px 0px 35px 0px;
    }
}

.checabox {
    text-align: left;
}

.mb-10 {
    margin-bottom: 10px;
}

.register-box {
    text-align: right;
    margin: 10px 0 0 0;
    .register-btn {
        color: #3399ff;
        cursor: pointer;
    }
}

</style>

<style scoped>
/* 覆盖样式 */
.login-input >>> .ivu-input-large {
    font-size: 14px;
}
</style>
